/* ============================================================
   MOTORFEST · Boletería vs Sponsor — JS de la subpágina
   Archivo: assets/motorfest-boleteria-sponsor.js
   ============================================================ */

function mfInitBoleteriaSponsor(context) {
  var scope = context || document;

  /* --- reveal on scroll --- */
  var targets = scope.querySelectorAll('.mf-reveal');
  if (targets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mf-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* --- acordeón de preguntas frecuentes --- */
  var items = scope.querySelectorAll('.mf-bvs__faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.mf-bvs__faq-q');
    var answer = item.querySelector('.mf-bvs__faq-a');
    if (!btn || !answer) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function (other) {
        other.classList.remove('is-open');
        var otherAnswer = other.querySelector('.mf-bvs__faq-a');
        if (otherAnswer) otherAnswer.style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mfInitBoleteriaSponsor(document);
});

// Compatibilidad con el editor de temas de Shopify (vista previa en vivo)
document.addEventListener('shopify:section:load', function (event) {
  mfInitBoleteriaSponsor(event.target);
});